module.exports = __webpack_public_path__ + "media/images/partners/bebras-3b8aa926f23648c7ee5db5206ee08617.png";